export default __webpack_public_path__ + "static/media/image_placeholder.61b9ec86.jpg";